import KendoDiagram from './KendoDiagram'
import KendoDiagramConnection from './KendoDiagramConnection'
import KendoDiagramShape from './KendoDiagramShape'
import KendoDiagramInstaller from './kendo-diagram-installer'

export { KendoDiagram, KendoDiagram as Diagram, KendoDiagramConnection, KendoDiagramConnection as DiagramConnection, KendoDiagramShape, KendoDiagramShape as DiagramShape, KendoDiagramInstaller, KendoDiagramInstaller as DiagramInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/index.js